import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { FormGroup } from '@angular/forms';
import { applyAuxError } from './helpers/conclusioni-form.helper';
import { addRemoveError, getControl, getGroup } from '@shared/helpers/form.helper';
import { isEqual } from 'lodash-es';
import { CkNormeValuesEnum } from '../../amm-controllo/common/consts/ckNormeValues.enum';
import { toNum } from '@shared/helpers/math.helper';
import { MyAllElemCollegioSindacaleEntity } from '../../../models/interfaces/revisione.interface';
import { formPaths } from '@shared/constants/form-paths.const';

/*
 * Le regole "attestato" per norma (SRL/SPO/SPD/SPM: revisori legali, soci, min. componenti,
 * CDA <3, amministratore unico legge di bilancio 2018, ecc.) sono coperte da
 * conclusioni-ck-proposte.rules.ts (chiave my_CkProposte), che replica fedelmente le condizioni
 * dell'XSF InfoPath legacy incluso il guard "CkProposte === '1'" mancante qui. Le due regole
 * rimaste sotto sono le uniche di questo file senza un equivalente completo in quel file (viste
 * le condizioni extra dell'XSF legacy per il cluster "obbligo di affidamento SRL" — righe
 * 14921/14924/14927/15695 di manifest.xsf, che si sovrappongono in modo non banale) — vedi memoria
 * conclusioni-attestato-duplicate-rules-bug.
 */
export const conclusioniAttestatoAmmControlloRules: FormGroupRules = {
    my_CkSrlAffidamContrCont: (form: FormGroup) => {
        const amministrazioneControlloGroup = getGroup(form, formPaths.ammControllo);
        const my_CkSrlAffidamContrContControl = getControl(amministrazioneControlloGroup, 'my_NormeSrl.my_CkSrlAffidamContrCont');
        const my_CkNorme: string = getControl(amministrazioneControlloGroup, 'my_CkNorme').value;
        const my_CalcObbOrganoContr: string = getControl(amministrazioneControlloGroup, 'my_CalcObbOrganoContr').value;
        const errors = my_CkSrlAffidamContrContControl.errors ? my_CkSrlAffidamContrContControl.errors : {};

        addRemoveError(
            !(
                (my_CkSrlAffidamContrContControl.value !== '7' && my_CkSrlAffidamContrContControl.value !== '8') ||
                my_CalcObbOrganoContr !== 'true' ||
                my_CkNorme !== CkNormeValuesEnum.normeSrl
            ),
            errors,
            'my_CkSrlAffidamContrCont',
            {
                status: "SRL: Obbligo di affidamento della revisione legale, non può essere rilasciato l'attestato di revisione",
            }
        );

        my_CkSrlAffidamContrContControl.setErrors(isEqual(errors, {}) ? null : errors);
        applyAuxError(form, 'ckSrlAffidamContrCont', errors, 'my_CkSrlAffidamContrCont');
    },

    my_CkSrlAffidamContrContV: (form: FormGroup) => {
        const amministrazioneControlloGroup = getGroup(form, formPaths.ammControllo);
        const my_CkSrlAffidamContrContControl = getControl(amministrazioneControlloGroup, 'my_NormeSrl.my_CkSrlAffidamContrCont');
        const my_CkNorme: string = getControl(amministrazioneControlloGroup, 'my_CkNorme').value;
        const my_CalcObbOrganoContr: string = getControl(amministrazioneControlloGroup, 'my_CalcObbOrganoContr').value;
        const my_AllElemCollegioSindacale: MyAllElemCollegioSindacaleEntity[] = getControl(
            amministrazioneControlloGroup,
            'my_AllCollegioSindacale.my_AllElemCollegioSindacale'
        ).value;
        const errors = my_CkSrlAffidamContrContControl.errors ? my_CkSrlAffidamContrContControl.errors : {};
        addRemoveError(
            !(my_CkNorme !== '1' || toNum(my_CkSrlAffidamContrContControl.value) < 6 || my_CalcObbOrganoContr !== 'true' || my_AllElemCollegioSindacale?.length > 0),
            errors,
            'my_CkSrlAffidamContrContV',
            {
                status: "SRL: Deve essere presente l'organo di controllo o nominato un revisore legale, non può essere rilasciato l'attestato di revisione.",
            }
        );

        my_CkSrlAffidamContrContControl.setErrors(isEqual(errors, {}) ? null : errors);
        applyAuxError(form, 'ckSrlAffidamContrContV', errors, 'my_CkSrlAffidamContrContV');
    },
};
